import { GET, POST } from "./api.js";
export const plans = {
    plansConsult: ( data) => GET(`/plans/selectplan`, data),
    homePlans: ()=> GET(`/plans/homeplans`),
    consultCompanies:()=> GET(`/plans/`)
}